// extracted by mini-css-extract-plugin
export default {"title":"HistoryPanel_title__b0lN3"};